/** @flow */

import type { State } from "@store/reducers";
import type {
  MySavedPresentations,
  SharedPresentations,
  MiSlides,
  MiLogs,
} from "@modules/reporting/reducer/reports/mi-reports/types";
import type { EmployeeType } from "@modules/employee/types";

export const mySavedPresentations = (state: State): Array<MySavedPresentations> =>
  ((((state || {}).reporting || {}).reports || {}).miReports || {}).mySavedPresentations
    .presentations;

export const sharedPresentations = (state: State): Array<SharedPresentations> =>
  ((((state || {}).reporting || {}).reports || {}).miReports || {}).sharedPresentations
    .presentations;

export const miSlides = (state: State): Array<MiSlides> =>
  ((((state || {}).reporting || {}).reports || {}).miReports || {}).miSlides.slides;

export const presentationLogs = (state: State): Array<MiLogs> =>
  (((((state || {}).reporting || {}).reports || {}).miReports || {}).miLogs || {}).logs;

export const shareEmployees = (state: State): Array<EmployeeType> =>
  (((((state || {}).reporting || {}).reports || {}).miReports || {}).shareEmployees || {}).list;

export const isLoading = (state: State): boolean =>
  ((((state || {}).reporting || {}).reports || {}).miReports || {}).requestsInProgress > 0;
